import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TypeOfDateSettingsEnumCharts} from "../../../../enums/dashboard/TypeOfDateSettingsEnumCharts";
import {BaseComponent} from "../../../BaseComponent";
import {UserMetricGroup} from "../../../../models/user/Metric/UserMetricGroup";
import validationEngine from "devextreme/ui/validation_engine";
import {TimeUnitEnum} from "../../../../enums/dashboard/TimeUnitEnum";
import {BucketUnitEnum} from "../../../../enums/dashboard/ChartsEnum";

@Component({
  selector: 'app-chart-time-selector',
  templateUrl: './chart-time-selector.component.html',
  styleUrls: ['./chart-time-selector.component.css']
})
export class ChartTimeSelectorComponent extends BaseComponent implements OnInit {
  @Input() userMetricGroup?: UserMetricGroup;
  @Output() dateIsValid = new EventEmitter<boolean>();
  @Output() bucketIsValid = new EventEmitter<boolean>();
  localBucketIsValid = true;
  telemetryBucketUnitValues: string[];
  telemetrySearchUnitValues: string[];
  /**
   * List containing all the values of the TypeOfDateSettingsEnumCharts enum
   * @protected
   */
  protected readonly typeOfDateSettings = Object.values(TypeOfDateSettingsEnumCharts);
  /**
   * The current timestamp
   * @protected
   */
  protected today = new Date();
  protected readonly TypeOfDateSettingsEnum = TypeOfDateSettingsEnumCharts;
  protected errorMsg: string = "";

  constructor() {
    super();
    this.telemetryBucketUnitValues = Object.values(BucketUnitEnum);
    this.telemetrySearchUnitValues = Object.values(TimeUnitEnum);
  }

  ngOnInit(): void {
    super.ngOnInit();
    // this.initializeToday();
  }


  // /**
  //  * Initializes timestamp of today and deepcopies the userMetricGroup
  //  */
  // initializeToday() {
  //   this.today = new Date();
  // }

  /**
   * Check if the startDate is valid
   * @param date
   */

  public checkStartDateValidity() {
    if (!!this.userMetricGroup) {
      if (this.userMetricGroup.selectedDateSettings === TypeOfDateSettingsEnumCharts.FIXED_DATE) {
        this.userMetricGroup.startDate = new Date(this.userMetricGroup?.startDate).getTime();
        this.userMetricGroup.endDate = new Date(this.userMetricGroup?.endDate).getTime()
        if (!!validationEngine.getGroupConfig('fromDate')) {
          let validDate: boolean = true;
          validDate = !!validationEngine.validateGroup('fromDate').isValid;
          if (this.userMetricGroup?.startDate > this.userMetricGroup?.endDate) {
            validDate = false;
            this.errorMsg = this.translate.instant("DATE_SELECTION.FIXED_DATE.START_DATE_ERROR_MSG");
          }
          return validDate;
        }
      }
    }
    return true;
  }

  /**
   * Lambda function used to parse the Date selection label
   * @param e
   */
  translateTimeUnit = (e: any) => {
    let unit = this.translate.instant('DATE_SELECTION.REALTIME.PLURAL.' + e);
    return unit.charAt(0).toUpperCase() + unit.slice(1);
  };

  checkForBucketsMax() {
    if (!!this.userMetricGroup) {
      let tsFrom = new Date();
      let tsTo = new Date();
      if (this.userMetricGroup.selectedDateSettings === "FIXED_DATE") {
        tsFrom = new Date(this.userMetricGroup.startDate);
        tsTo = new Date(this.userMetricGroup.endDate)
      } else if (this.userMetricGroup.selectedDateSettings === TypeOfDateSettingsEnumCharts.REALTIME) {
        let now = new Date();
        tsTo = now;
        switch (this.userMetricGroup.realTimeUnit) {
          case TimeUnitEnum.MINUTES:
            tsFrom = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes() - this.userMetricGroup.realtimeValue, now.getSeconds());
            break;
          case TimeUnitEnum.HOURS:
            tsFrom = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours() - this.userMetricGroup.realtimeValue, now.getMinutes(), now.getSeconds());
            break;
          case TimeUnitEnum.DAYS:
            tsFrom = new Date(now.getFullYear(), now.getMonth(), now.getDate() - this.userMetricGroup.realtimeValue, now.getHours(), now.getMinutes(), now.getSeconds());
            break;
          case TimeUnitEnum.WEEKS:
            tsFrom = new Date(now.getFullYear(), now.getMonth(), now.getDate() - this.userMetricGroup.realtimeValue * 7, now.getHours(), now.getMinutes(), now.getSeconds());
            break;
          case TimeUnitEnum.MONTHS:
            tsFrom = new Date(now.getFullYear(), now.getMonth() - this.userMetricGroup.realtimeValue, now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds());
            break;
          case TimeUnitEnum.YEARS:
            tsFrom = new Date(now.getFullYear() - this.userMetricGroup.realtimeValue, now.getMonth(), now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds());
            break;
        }
      }
      let c = this.numberOfBucketsBetween(
        tsFrom,
        tsTo,
        this.userMetricGroup.bucketUnits,
        this.userMetricGroup.bucketValue,
        (!!this.userMetricGroup.metrics) ? this.userMetricGroup.metrics.length : 0);
      if (this.gmService.maxTelemetryPointListSize !== null && c > this.gmService.maxTelemetryPointListSize) {
        this.errorMsg = this.translate.instant("CHART_CREATION.BUCKET_OVER_MAX") + " ~" + Math.round(c) + " (max " + this.gmService.maxTelemetryPointListSize + ")";
        this.localBucketIsValid = false;
        this.bucketIsValid.emit(false);
        return;
      } else {
        this.errorMsg = "";
        this.localBucketIsValid = true;
        this.bucketIsValid.emit(true);
      }
    }
  }

  numberOfBucketsBetween(from: Date, to: Date, bucketUnits: string, bucketValues: number, metricsNumber: number) {
    if (bucketValues == null || bucketUnits == null)
      return 0;
    let millisBetween = this.millisBetween(from, to);
    let millisInUnit = this.millisInUnit(bucketUnits);
    return (millisBetween / millisInUnit) / bucketValues;
  }

  millisBetween(d1: Date, d2: Date) {
    if (d1 == null && d2 == null)
      return 0;
    if (d1 == null || d2 == null)
      throw new Error("Dates shall not be null!");
    return Math.abs(d1.getTime() - d2.getTime());
  }

  getAcquisitionCronLabel = (acquisitionCron: string) => {
    let val = this.translate.instant('DATE_SELECTION.REALTIME.PLURAL.' + acquisitionCron);
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  }

  private millisInUnit(bucketUnits: string) {
    switch (bucketUnits) {
      case "SECONDS":
        return 1000;
      case "MINUTES":
        return 1000 * 60;
      case "HOURS":
        return 1000 * 60 * 60;
      case "DAYS":
        return 1000 * 60 * 60 * 24;
      case "MONTHS":
        return 1000 * 60 * 60 * 24 * 30;
      case "YEARS":
        return 1000 * 60 * 60 * 24 * 365;
      default:
        throw new Error("Invalid Bucket Unit");
    }
  }

}
